// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"566":"8b3e316b","628":"915667da","963":"a4332311","988":"dfec2777"}[chunkId] + ".chunk.js";
};